export const PROFILE = "Profile"

export const GIFTS = "Gifts"
export const GIFTS_BY_CUSTOMER = "GiftsByCustomer"
export const GIFT_EXCHANGE_HISTORY = "GiftExchangeHistory"
export const GIFT_ORDER = "GiftOrder"
export const TEM_ACCUMULATION_HISTORY = "TemAccumulationHistory"
export const GIFT_SELECT_LIST = "GiftSelectList"

export const ORDER_BY_CODE = "OrderByCode"
export const CUSTOMER_DETAILS = "CustomerDetails"

export const STORES = "Stores"

export const AUTHEN_ID = "AuthenId"
